import { styled } from "@mui/material/styles";
import { HubCardStack } from "../HubCardStack";
import { Box, Stack } from "@mui/material";
import { HubHookFormDatePicker } from "../HubHookFormDatePicker";
import { HubButton } from "../inputs";

const highlightColor = "white";
const inputColor = "blueMainTransparent";

export const TablesStack = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "10px",
}));

export const BasicCardStack = styled(HubCardStack)(({ theme }) => ({
  padding: "5px",
  borderRadius: 0,
  borderColor: theme.palette.hubColors.grey,
  "span, p": { lineHeight: 1 },
  ".ItemCell-root": {
    paddingLeft: "5px",
  },
  span: {
    fontSize: "11px",
  },
}));

export const StyledCardStack = styled(BasicCardStack, {
  shouldForwardProp: (prop) => !["borderRight"].includes(prop),
})(({ theme, borderRight }) => ({
  padding: "0px",
  width: "100%",
  ".MuiStack-root": {
    padding: "5px",
    width: "fit-content",
    minWidth: "178px",
  },
  ".HubHookSearchField-stack": {
    width: "100%",
    padding: "0px !important",
    ".HubSearch-Stack, .MuiInputBase-root": {
      width: "100%",
    },
    ".MuiStack-root": {
      padding: "0px !important",
    },
  },
  ...(!borderRight && { borderRight: "0px" }),
}));

export const StyledCardRow = styled(BasicCardStack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
}));

export const StyledQuoteRow = styled(Stack, {
  shouldForwardProp: (prop) =>
    !["header", "includePadding", "removeBorder"].includes(prop),
})(({ theme, header, removeBorder }) => ({
  display: "grid",
  columnGap: "2px",
  gridTemplateColumns: "repeat(4, 1fr)",
  padding: "0px 0px 0px 10px",
  alignItems: "center",
  borderBottom: "1px solid",
  borderColor: theme.palette.hubColors.grey,
  gridAutoRows: "22px",
  position: "relative",
  ...(header
    ? {
        backgroundColor: theme.palette.hubColors.greyLight,
      }
    : {}),
  ...(removeBorder ? { border: 0 } : {}),

  span: {
    fontSize: "11px",
  },
}));

export const StyledItemRow = styled(Stack, {
  shouldForwardProp: (prop) =>
    !["header", "topBorder", "includePadding", "rowHeight"].includes(prop),
})(({ theme, header, topBorder }) => ({
  display: "grid",
  columnGap: "2px",
  gridTemplateColumns: "35px 75px 50px auto 100px 100px",
  padding: "0px 0px 0px 10px",
  alignItems: "center",
  borderColor: theme.palette.hubColors.greyLight,
  gridAutoRows: "24px",
  position: "relative",
  ":hover": {
    ".AddButton": {
      display: "flex",
    },
  },
  ...(topBorder
    ? {
        borderTop: "1px solid",
      }
    : {
        borderBottom: "1px solid",
      }),
  ...(header
    ? {
        backgroundColor: theme.palette.hubColors.greyLight,
      }
    : {}),
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "start",
    alignItems: "center",
    width: "100%",
    height: "100%",
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".MuiInputBase-root, input, fieldset": {
      height: "100%",
      border: "0px",
    },
    "input, fieldset": {
      backgroundColor: "transparent",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      padding: "5px 2px 5px 4px",
      border: "0px",
      backgroundColor: theme.palette.hubColors[inputColor],
      borderRadius: "0px",
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: 700,
        color: theme.palette.hubColors.greyDark,
        lineHeight: "11px",
        fontSize: "11px",
      },
    },
    ".MuiAutocomplete-root": {
      width: "100%",
      height: "100%",
      padding: "0px",
      ".MuiInputBase-root": {
        input: {
          fontWeight: 500,
        },
      },
    },
  },
}));

export const StyledLabelStack = styled(Stack, {
  shouldForwardProp: (prop) => !["c1"].includes(prop),
})(({ c1 = "100px" }) => ({
  display: "grid",
  gridTemplateColumns: `${c1} 1fr`,
  alignItems: "end",
  columnGap: "5px",
  width: "100%",
}));

export const StyledGridStack = styled(Stack, {
  shouldForwardProp: (prop) => !["isLast"].includes(prop),
})(({ theme, isLast = false }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  justifyItems: "end",
  alignItems: "center",
  gap: "5px",
  width: "100%",
  height: "22.5px",
  ".PurchaseOrderLabel-value": {
    width: "100%",
    minWidth: "100px",
    padding: "2px",
    border: "1px solid",
    ...(isLast ? {} : { borderBottom: "0px" }),
    borderColor: theme.palette.hubColors.greyDark,
    backgroundColor: theme.palette.hubColors[highlightColor],
    height: "100%",
  },
}));

export const StyledFobStack = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "end",
  ".HubCustomerSelect-root": {
    ".MuiFormControl-root": {
      display: "flex",
    },
  },
  ".MuiAutocomplete-root": {
    width: "100%",
  },
  ".HubHookSearchField-stack": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    justifyItems: "end",
    alignItems: "center",
    gap: "5px",
    width: "100%",
    ".MuiTypography-root": {
      margin: "0px",
    },
    ".MuiFormControl-root": {
      display: "flex",
    },
  },
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    justifyItems: "end",
    alignItems: "center",
    gap: "5px",
    width: "100%",
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".isLast": {
      borderBottom: "1px solid !important",
      borderColor: theme.palette.hubColors.greyDark,
    },
    ".MuiInputBase-root, input, fieldset": {
      border: "0px",
      backgroundColor: "transparent",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      minWidth: "100px",
      padding: "2px 2px 2px 4px !important",
      border: "1px solid",
      borderBottom: "0px",
      borderColor: theme.palette.hubColors.greyDark,
      backgroundColor: theme.palette.hubColors[inputColor],
      borderRadius: "0px",
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: "700",
        color: theme.palette.hubColors.greyDark,
        lineHeight: "11px",
        fontSize: "11px",
      },
    },
  },
}));

export const StyledHeaderStack = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  alignItems: "start",
  ".HubCustomerSelect-root": {
    ".MuiFormControl-root": {
      display: "flex",
    },
  },
  ".MuiAutocomplete-root": {
    width: "100%",
    height: "22.5px",
  },
  ".HubHookSearchField-stack": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    justifyItems: "end",
    alignItems: "center",
    gap: "5px",
    width: "100%",
    ".MuiTypography-root": {
      margin: "0px",
    },
    ".MuiFormControl-root": {
      display: "flex",
    },

    height: "22.5px",
  },
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    justifyItems: "end",
    alignItems: "center",
    gap: "5px",
    width: "100%",
    height: "22.5px",
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".isLast": {
      borderBottom: "1px solid !important",
      borderColor: theme.palette.hubColors.greyDark,
    },
    ".MuiInputBase-root, input, fieldset": {
      border: "0px",
      backgroundColor: "transparent",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      minWidth: "100px",
      padding: "2px 2px 2px 4px !important",
      border: "1px solid",
      borderBottom: "0px",
      borderColor: theme.palette.hubColors.greyDark,
      backgroundColor: theme.palette.hubColors[inputColor],
      borderRadius: "0px",
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: "700",
        color: theme.palette.hubColors.greyDark,
        lineHeight: "11px",
        fontSize: "11px",
      },
    },
  },
}));

export const StyledUserBox = styled(Box, {
  shouldForwardProp: (prop) => !["isUser"].includes(prop),
})(({ isUser, theme }) => ({
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "start",
    alignItems: "center",
    width: "100%",
    overflow: "visible",
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".MuiInputBase-root, input, fieldset": {
      height: "100%",
      border: "0px",
    },
    "input, fieldset": {
      backgroundColor: "transparent",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      height: "25px",
      padding: "5px 2px 5px 4px",
      border: "0px",
      borderBottom: "1px solid",
      borderColor: theme.palette.hubColors.greyDark,
      backgroundColor: theme.palette.hubColors[inputColor],
      borderRadius: "0px",
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: 500,
        color: theme.palette.hubColors.greyDark,
        ...(isUser ? {} : { fontSize: "13px" }),
      },
    },
  },
}));

export const StyledShipmentBox = styled(Stack)(({ theme }) => ({
  minWidth: "250px",
  padding: "0px !important",
  gap: "2px",
  ".MuiFormControl-root": {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "end",
    alignItems: "center",
    width: "100%",
    height: "fit-content",
    ".MuiStack-root": {
      padding: 0,
      backgroundColor: "transparent",
    },
    ".MuiTypography-inputLabelSmall": {
      margin: 0,
      ".MuiTypography-inputLabelSmall": {
        display: "none",
      },
    },
    ".MuiInputBase-root, input, fieldset": {
      border: "0px",
    },
    ".MuiAutocomplete-root": {
      width: "100%",
      minWidth: "100px",
      padding: "0px",
    },
    ".MuiInputBase-root.Mui-error": {
      backgroundColor: theme.palette.hubColors.redMainErrorBg,
    },
    ".MuiInputBase-root": {
      width: "100%",
      minWidth: "100px",
      padding: "5px !important",
      borderRadius: "0px",
      backgroundColor: theme.palette.hubColors[inputColor],
      ".MuiSelect-select": {
        display: "flex",
        alignItems: "center",
      },
      ".MuiSvgIcon-root": {
        display: "none",
      },
      ".MuiTypography-root, input, textarea": {
        fontWeight: "700",
        color: theme.palette.hubColors.greyDark,
        lineHeight: "11px",
        fontSize: "11px",
      },
    },
  },
}));

export const StyledHubHookFormDatePicker = styled(HubHookFormDatePicker)(
  ({ theme }) => ({
    ".MuiInputBase-root": {
      display: "grid",
      gridTemplateColumns: "auto 20px",
      "input::placeholder": {
        color: theme.palette.hubColors.greyDark,
      },
      ".MuiInputAdornment-root": {
        height: "fit-content",
        maxHeight: "fit-content",
        margin: 0,
        ".MuiButtonBase-root": {
          padding: "0px",
        },
      },
    },
    ".MuiSvgIcon-root": {
      display: "inline-block !important",
      width: "14px",
      height: "14px",
    },
  }),
);

export const StyledHubButton = styled(HubButton, {
  shouldForwardProp: (prop) => !["direction"].includes(prop),
})(({ direction = "right", theme }) => ({
  position: "absolute",
  [direction]: "-5px",
  minWidth: "20px !important",
  width: "20px !important",
  height: "20px",
  padding: "0px",
  backgroundColor: "transparent",
  display: "none",
  svg: {
    width: "15px",
    height: "15px",
  },
}));
